// extracted by mini-css-extract-plugin
export default {"item":"Statuses_item__ktsh+"};